import React from 'react';
import { useHistory } from 'react-router-dom';

import '../../teacher_payments/teacher_payments.css';
import { payment_details_url } from './logic';

// entry point on the teacher profile; the cards themselves self-gate on the page.
const PaymentDetailsButton = ({ teacher_uuid }) => {
  const history = useHistory();
  if (!teacher_uuid) return null;
  return (
    <button
      type="button"
      className="tp-btn-out"
      onClick={() => history.push(payment_details_url(teacher_uuid))}
    >
      Payment details
    </button>
  );
};

export default PaymentDetailsButton;
